module.exports = __webpack_public_path__ + "media/images/rocket_pro-73fbd53b9c61e150d2d21eb879a7b572.svg";